export default __webpack_public_path__ + "static/media/profile-picture.0cca7c9c.png";